import { render, staticRenderFns } from "./nxUpload.vue?vue&type=template&id=62cf48bb&scoped=true&"
import script from "./nxUpload.vue?vue&type=script&lang=js&"
export * from "./nxUpload.vue?vue&type=script&lang=js&"
import style0 from "./nxUpload.vue?vue&type=style&index=0&id=62cf48bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cf48bb",
  null
  
)

export default component.exports